import React, { useEffect } from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

import SubmissionThumbnailList from '@components/Submission/Thumbnail/List/List'
import { useSubmission } from '@context/Submission'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import { selectInfluencerSubmissionIds } from '@store/submissions'

const EMPTY_IDS: ReadonlyArray<number> = []
import { fetchInfluencerSubmissionsRequest } from '@store/submissions/actions/influencerSubmissions'
import Theme from '@theme'
import { H3 } from '@tribegroup'
import { Wrapper } from './Submissions.styled'

export const InfluencerSubmissions: React.FC = () => {
  const campaignId = useCampaignIdFromRoute()
  const dispatch = useDispatch()
  const { submission, isSubmissionFetched } = useSubmission()

  const influencerSubmissionIds = useSelector((state: IApplicationState) =>
    isSubmissionFetched
      ? selectInfluencerSubmissionIds(state, submission.influencer_id, campaignId)
      : EMPTY_IDS,
  )

  const shouldDisplayList = isSubmissionFetched && influencerSubmissionIds.length > 1

  useEffect(() => {
    if (!isSubmissionFetched) {
      return
    }
    dispatch(fetchInfluencerSubmissionsRequest(submission.id, submission.influencer_id, campaignId))
  }, [submission?.id, isSubmissionFetched])

  if (!shouldDisplayList) {
    return null
  }

  return (
    <Wrapper>
      <H3 color={Theme.defaultColor}>
        <FormattedMessage
          id="submission.fullView.influencerSubmissions.header"
          values={{ firstName: submission.influencer_first_name }}
        />
      </H3>
      <SubmissionThumbnailList
        influencerSubmissionIds={influencerSubmissionIds}
        fromSubmission={submission}
      />
    </Wrapper>
  )
}

export default InfluencerSubmissions
